<mat-spinner class="xp-loading__spinner" [diameter]="diameter()"></mat-spinner>
